import pdfMake from 'pdfmake';
import handlePurchase from "@/services/modules/purchase";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { toCapitalizeFirst } from '@/services/utils/global.js'
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => {

    const {currencyToDigitWord} = handlePurchase();
    const exportToPDF = (company, invoice, barcode = '', qrcode, userName, btnFunc, invoiceNotes = [],orderSale = false, customizationFields = []) => {
        const tableItems = invoice.has_item_detail ? invoice.general : invoice.ledgers;
        var doc = {
            pageSize: 'A4',
            pageMargins: [ 60, 100, 30, 80 ],
            header: getHeader(company, customizationFields),
            footer: getFooter(userName, qrcode, customizationFields),
            content: getContent(invoice, tableItems, barcode, btnFunc, invoiceNotes, orderSale, customizationFields, company),

            styles : {
                header: {
                    fontSize: 18,
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },
            info: {
                title: invoice.bill_number
            }
        }

        pushIntoTable(doc, invoice, tableItems, btnFunc, customizationFields)
        if (btnFunc == 1){
            pushIntoTableTotal(doc, invoice, tableItems, customizationFields)
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    }
    const formatDate = (date) => {
        var formattedDate = date.toISOString().split('T')[0];
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var amOrPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;
        return formatToDdMmYy(formattedDate) + ' ' + formattedTime
    }
    const formatToDdMmYy = (date) => {
        var dat = date.split('-');
        return `${dat[2]}-${dat[1]}-${dat[0]}`;
    }
    const getHeader = (company, customizationFields) => {
        return {
            margin: [ 60, 25, 30, 10 ],
            columns: [
                shouldInclude(customizationFields,'heading_left_logo') && company.logo64
                    ? {
                        alignment: 'left',
                        image: company.logo64,
                        maxHeight: 60
                    }
                    : null,

                {
                    alignment: 'right',
                    stack: [
                        (shouldInclude(customizationFields,'heading_right_company_name') && company.name) ? company.name : '',
                        (shouldInclude(customizationFields,'heading_right_company_address') && company.address) ? 'Address: ' + company.address : '',
                        (shouldInclude(customizationFields,'heading_right_company_phone') && company.phone) ? 'Phone: ' + company.phone : '',
                        (shouldInclude(customizationFields,'heading_right_company_email') && company.email) ? 'E-mail: ' + company.email : '',
                        (shouldInclude(customizationFields,'heading_right_vat_reg_number') && company.vat_no) ? 'VAT Reg No: ' + company.vat_no : '',
                    ]
                }
            ]
        }
    }
    const getContent = (invoice, tableItems, barcode, btnFunc, invoiceNotes, orderSale, customizationFields, company) => {
        return  [
            {
                text: (btnFunc == 1) ? 'INVOICE' : 'DELIVERY CHALLAN',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 5],
                bold: true,
                color: 'black',
            },
            {
                margin: [0, 0, 20, 5],
                alignment: 'center',
                color: 'black',
                bold: true,
                fontSize: 12,
                text:(btnFunc === 1 && orderSale && invoice.sale_type_title && invoice.sale_type_title !== '' && shouldInclude(customizationFields,'body_top_sale_type_title')) ?
                    '(' + invoice.sale_type_title +  ')' : '',
            },
            {
                margin: [0, 5, 0, 0],
                alignment: 'justify',
                columns: [
                    {
                        width: '50%',
                        stack: [
                            {
                                text: (btnFunc == 1) ? 'INVOICE TO' : 'SHIP TO',
                                color: 'black',
                                bold: true,
                            },

                            (shouldInclude(customizationFields,'body_top_left_contact_name') && invoice.contact) ? {
                                text: invoice.contact.name,
                                alignment: 'left',
                                width: '50%'
                            } : '',

                            (shouldInclude(customizationFields,'body_top_left_address') && invoice.contact) ? {
                                text: invoice.contact.full_address ? 'Address: ' + invoice.contact.full_address : '',
                                alignment: 'left',
                                width: '50%'
                            } : '',

                            (shouldInclude(customizationFields,'body_top_left_phone') && invoice.contact) ? {
                                text: getProfileItemByField(invoice.contact.profile_items, 'phone') ?
                                    'Mobile No: ' + getProfileItemByField(invoice.contact.profile_items, 'phone') : ''
                            } : '',

                            (shouldInclude(customizationFields,'body_top_left_billing_address') && invoice.contact) ? {
                                text: getProfileItemByField(invoice.contact.profile_items, 'billing_address') ?
                                      'Address: ' + getProfileItemByField(invoice.contact.profile_items, 'billing_address') : ''
                            } : '',

                            (shouldInclude(customizationFields,'body_top_left_contact_address') && invoice.contact) ? {
                                text: `${invoice.contact.address ? 'Address: ' + invoice.contact.address : ''}`
                            } : '',

                            (invoice.destination_address && shouldInclude(customizationFields,'body_top_left_delivery_location')) ? {
                                text: [
                                    {
                                        text: 'Delivery Location: ',
                                        bold: true,
                                    },
                                    {
                                        text: invoice.destination_address,
                                    }
                                ],
                                margin: [0, 5, 0, 0]
                            } : '',

                            (invoice.transport_reference && shouldInclude(customizationFields,'body_top_left_transport_number')) ? {
                                text: [
                                    {
                                        text: 'Transport Type & Number: ',
                                        bold: true,
                                    },
                                    {
                                        text: invoice.transport_reference,
                                    }
                                ],
                                margin: [0, 5, 0, 0]
                            } : '',

                            (invoice.project && shouldInclude(customizationFields,'body_top_left_project_name')) ? {
                                text: [
                                    {
                                        text: 'Tracking Reference: ',
                                        bold: true,
                                    },
                                    {
                                        text: invoice.project.name,
                                    }
                                ],
                                margin: [0, 5, 0, 0]
                            } : '',

                            (invoice.lc_number && shouldInclude(customizationFields,'body_top_left_lc_number')) ? {
                                text: [
                                    {
                                        text: 'LC Number: ',
                                        bold: true,
                                    },
                                    {
                                        text: invoice.lc_number,
                                    }
                                ],
                                margin: [0, 5, 0, 0]
                            } : '',
                        ]

                    },

                    {
                        alignment: 'right',
                        stack: [
                            shouldInclude(customizationFields,'body_top_right_date') ? {
                                text: [
                                    {
                                        text: (btnFunc == 1) ? 'DATE: ' : 'CHALLAN DATE: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },

                                    {
                                        text: formatToDdMmYy(invoice.date),
                                    }
                                ]
                            } : '',

                            (btnFunc === 1 && !orderSale && invoice.sale_type_title && invoice.sale_type_title !== '' &&  shouldInclude(customizationFields,'body_top_right_sale_type_title')) ? {
                                text: [
                                    {
                                        text: 'Sale Type: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },
                                    {
                                        text: invoice.sale_type_title,
                                    }
                                ]
                            } : '',
                            (barcode && shouldInclude(customizationFields,'body_top_right_bill_number')) ? {
                                text: [
                                    {
                                        text: (btnFunc == 1) ? 'INVOICE REF: ' : 'CHALLAN NO: ',
                                        bold: true,
                                        margin: [0, 0, 20, 0]
                                    },

                                    {
                                        text: invoice.bill_number
                                    }
                                ]
                            } : '',

                            (barcode && shouldInclude(customizationFields,'body_top_right_barcode')) ? {
                                svg: barcode
                            } : '',

                            (invoice.sales_person && shouldInclude(customizationFields,'body_top_right_sales_person')) ? {
                                text: [
                                    {
                                        text: 'Sales Person: ',
                                        bold: true,
                                    },
                                    {
                                        text: invoice.sales_person.name,
                                    }
                                ],
                                margin: [0, 5, 0, 0]
                            } : '',

                            (invoice.business && shouldInclude(customizationFields,'body_top_right_business_name')) ? {
                                text: [
                                    {
                                        text: 'Business Name: ',
                                        bold: true,
                                    },
                                    {
                                        text: invoice.business.name,
                                    }
                                ],
                                margin: [0, 5, 0, 0]
                            } : '',

                            (invoice.cost_centre && shouldInclude(customizationFields,'body_top_right_cost_centre')) ? {
                                text: [
                                    {
                                        text: 'Cost Center: ',
                                        bold: true,
                                    },
                                    {
                                        text: invoice.cost_centre.name,
                                    }
                                ],
                                margin: [0, 5, 0, 0]
                            } : '',

                            (invoice.order_number && shouldInclude(customizationFields,'body_top_right_order_number')) ? {
                                text: [
                                    {
                                        text: 'Order Number: ',
                                        bold: true,
                                    },
                                    {
                                        text: invoice.order_number,
                                    }
                                ],
                                margin: [0, 5, 0, 0]
                            } : '',

                            (invoice.location_name && shouldInclude(customizationFields,'body_top_right_ship_from')) ? {
                                text: [
                                    {
                                        text: 'Ship From: ',
                                        bold: true,
                                    },
                                    {
                                        text: invoice.location_name,
                                    }
                                ],
                                margin: [0, 5, 0, 0]
                            } : '',

                            (invoice.commission_amount && shouldInclude(customizationFields,'body_top_right_commission_amount')) ? {
                                text: [
                                    {
                                        text: 'Commission: ',
                                        bold: true,
                                    },
                                    {
                                        text: invoice.commission_amount + (invoice.commission_percent ? ` (${invoice.commission_percent}%)` : '')
                                    }
                                ],
                                margin: [0, 5, 0, 0]
                            } : '',
                        ]
                    },
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: getTableWidth(btnFunc, tableItems, customizationFields, invoice),
                    body: []
                },
                layout: {
			        fillColor: function (rowIndex,node) {
                       const lastRowIndex = node.table.body.length - 1;
                       return (rowIndex === 0 || rowIndex === lastRowIndex) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function () {
                        return 0.5;
                    },
                    vLineWidth: function () {
                        return 0.5;
                    }
		        }
		    },


            {
                columns: [
                    (btnFunc == 1 && shouldInclude(customizationFields,'body_bottom_in_words_amount')) ?
                    {
                        width: '55%',
                        text: [
                            {
                                text: 'In Words: ',
                                bold: true
                            },

                            {
                                text: invoice.total_amount ? currencyToDigitWord(invoice.total_amount) : ''
                            }
                        ]
                    }  : '',
                     
                    (btnFunc == 1 && formatTotals(invoice, customizationFields).length > 0) ? {
                        table: {
                            widths: ['*', '*'],
                            alignment: 'right',
                            body: formatTotals(invoice, customizationFields)
                        },
                        layout: {
                            hLineWidth: function () {
                                return 0.5;
                            },
                            vLineWidth: function () {
                                return 0.5;
                            }
                        }
                    } : ''
                ],
                margin: [0, 10]
            },

            (invoiceNotes.length && shouldInclude(customizationFields,'body_bottom_terms_condition')) ? {
                alignment: 'left',
                stack: formatInvoiceTerms(invoiceNotes)
            } : '',

            formatSignature(customizationFields, company, invoice),
        ]
    }
    const getTableWidth = (btnFunc, tableItems, customizationFields, invoice) => {
        if (btnFunc != 1) {
            return  ['*', 'auto', 'auto', 'auto']
        }

        const hasFreeQuantity = tableItems.find(item => item.free_quantity > 0);
        const hasTradeDiscount = tableItems.find(item => item.discount_amount > 0);
        const hasOfferDiscount = tableItems.find(item => item.offer_discount > 0);
        const hasVatAmount = tableItems.find(item => item.vat_amount > 0);
        const hasVatPercentage = tableItems.find(item => item.vat > 0);

        const rowStructure = [];

        if (shouldInclude(customizationFields,'body_table_sl')){
            rowStructure.push('auto')
        }

        rowStructure.push('*');

        if (shouldInclude(customizationFields,'body_table_description')){
            rowStructure.push('auto')
        }

        if (shouldInclude(customizationFields,'body_table_sku')){
            rowStructure.push('auto')
        }

        if (shouldInclude(customizationFields,'body_table_mrp')){
            rowStructure.push('auto')
        }

        if (shouldInclude(customizationFields,'body_table_qty')){
            rowStructure.push('auto')
        }

        if (shouldInclude(customizationFields,'body_table_rate')){
            rowStructure.push('auto')
        }

        if (shouldInclude(customizationFields,'body_table_rate') && invoice.vat_type == 'vat_inclusive'){
            rowStructure.push('auto')
        }

        rowStructure.push('auto');

        if (!! hasFreeQuantity && shouldInclude(customizationFields,'body_table_bonus_qty')) {
            rowStructure.push('auto');
        }

        if (!! hasTradeDiscount && shouldInclude(customizationFields,'body_table_trade_discount')) {
            rowStructure.push('auto');
        }

        if (!! hasOfferDiscount && shouldInclude(customizationFields,'body_table_offer_discount')) {
            rowStructure.push('auto');
        }

        if (!! hasVatPercentage && shouldInclude(customizationFields,'body_table_vat_percentage')) {
            rowStructure.push('auto');
        }

        if (!! hasVatAmount && shouldInclude(customizationFields,'body_table_vat_amount')) {
            rowStructure.push('auto');
        }

        if (
            (!! hasTradeDiscount && shouldInclude(customizationFields,'body_table_trade_discount')) ||
            (!! hasOfferDiscount && shouldInclude(customizationFields,'body_table_offer_discount')) ||
            (!! hasVatAmount && shouldInclude(customizationFields,'body_table_vat_amount'))
        ) {
            rowStructure.push('auto');
        }

        return  rowStructure;
    }

    function shouldInclude(customizationFields, key) {
        return Object.keys(customizationFields).length === 0 || customizationFields[key];
    }

    const getFooter = (userName, qrcode, customizationFields) =>{
        return {
            margin: [ 60, 0, 30, 0 ],
            columns: [
                {
                    columns: [
                       shouldInclude(customizationFields,'footer_qrcode') ? {
                            svg: qrcode
                        } : '',

                        shouldInclude(customizationFields,'footer_note') ? {
                            width: '90%',
                            alignment: 'left',
                            text: 'N.B: This is a system generated documents and requires no manual signature.',
                            margin: [5, 53, 0, 0],
                            fontSize: 8
                        } : ''
                    ]
                },

                shouldInclude(customizationFields,'footer_printed_by') ? {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        {
                            text: 'Printed by',
                            bold: true
                        },
                        {
                            text: userName
                        },
                        {
                            text: formatDate(new Date())
                        }
                    ]
                } : ''
            ]
        }
    }

    const getProfileItemByField = (profile_items, keyValue) => {
        const item = profile_items.find(item => item.field === keyValue);
        return (item) ? item.value : '';
    }

    const formatTotals = (invoice, customizationFields) => {
        const paidAmount = getAdjustedBillAmount(invoice, 'paid_amount');

        const totals = [
            (shouldInclude(customizationFields,'body_totals_table_subtotal_amount')) ?
            [{ text: 'Amount', bold: true }, { text: (invoice && invoice.is_order) ? formatCurrency(invoice.total_sale_amount) : formatCurrency(calculateSubtotal(invoice)), alignment: 'right'}]
            : null,

            (invoice.vat_amount && shouldInclude(customizationFields,'body_totals_table_vat_amount')) ?
              [ { text: 'VAT Amount', bold: true }, {text:  formatCurrency(invoice.vat_amount), alignment: 'right' } ] : null,

            (invoice.vat_amount && shouldInclude(customizationFields,'body_totals_table_total_amount')) ?
              [{ text: 'Total Amount', bold: true }, { text: formatCurrency(calculateSubtotal(invoice, true)), alignment: 'right'}] : null,

            (invoice.round_up_discount && shouldInclude(customizationFields,'body_totals_table_round_up_discount')) ?
              [ { text: 'Discount/Adjustment', bold: true }, {text:  formatCurrency(invoice.round_up_discount), alignment: 'right' } ] : null,

            (invoice.round_up_discount && shouldInclude(customizationFields,'body_totals_table_total_invoice_amount')) ?
                [ { text: 'Total Invoice Amount', bold: true }, { text: formatCurrency(invoice.total_amount), alignment: 'right'}] : null,

            (invoice.advance_adj_amount && shouldInclude(customizationFields,'body_totals_table_already_paid_adjustment')) ?
              [ { text: 'Already Paid/Adj.', bold: true }, {text:  formatCurrency(invoice.advance_adj_amount), alignment: 'right' } ] : null,

            (invoice.adjustment_amount && shouldInclude(customizationFields,'body_totals_table_discount_adjustment')) ?
                [ { text: 'Discount/Adjustment', bold: true }, {text:  formatCurrency(invoice.adjustment_amount), alignment: 'right' } ] : null,

            (invoice.adjustment_amount && shouldInclude(customizationFields,'body_totals_table_total_invoice_amount')) ?
                [ { text: 'Total Invoice Amount', bold: true }, { text: formatCurrency(invoice.total_amount), alignment: 'right'}] : null,

            ((invoice.round_up_discount || (invoice.advance_adj_amount)) && shouldInclude(customizationFields,'body_totals_table_net_bill_amount')) ?
            [ { text: 'Net Bill Amount', bold: true }, { text: formatCurrency(getAdjustedBillAmount(invoice)), alignment: 'right'}] : null,
        ].filter((item) => item !== null)

        if(! paidAmount || !shouldInclude(customizationFields,'body_totals_table_paid_amount')) return totals;

        if (paidAmount && shouldInclude(customizationFields, 'body_totals_table_paid_amount')) {
            totals.push(
                [{ text: 'Amount Paid', bold: true }, { text: formatCurrency(paidAmount), alignment: 'right' }],
                [{ text: 'Total Payable', bold: true }, { text: formatCurrency(invoice.total_amount - invoice.paid_amount), alignment: 'right' }]
            );
        }

        return totals.length > 0 ? totals : [];
    }

    const calculateSubtotal = (invoice, withVat = false) => {
        const roundUpDiscount = invoice.round_up_discount ?? 0;
        const totalDiscount = invoice.total_discount ?? 0;
        const discountBeforeRoundUp = totalDiscount - roundUpDiscount;
        let subTotal = invoice.subtotal_amount - discountBeforeRoundUp;
        if (invoice.adjustment_amount) {
            subTotal = subTotal + invoice.adjustment_amount;
        }

        if (withVat) {
            subTotal = subTotal + invoice.vat_amount;
        }

        return subTotal;
    }

    const getAdjustedBillAmount = (invoice, key = 'total_amount' ) => {
        if (invoice.advance_adj_amount) {
            return invoice[key] - invoice.advance_adj_amount;
        }

        return invoice[key]
    }

    const formatInvoiceTerms = (terms) => {
        return  terms.map((item) => {
            return {
                text: `${item.full_desc}`
            }
        })
    }

    let srNumber = 0;
    const pushIntoTable = (doc, invoice, tableItems, btnFunc, customizationFields) => {
        srNumber = 0;
        const hasFreeQuantity = tableItems.find(item => item.free_quantity > 0);
        const hasTradeDiscount = tableItems.find(item => item.discount_amount > 0);
        const hasOfferDiscount = tableItems.find(item => item.offer_discount > 0);
        const hasVatAmount = tableItems.find(item => item.vat_amount > 0);
        const hasVatPercentage = tableItems.find(item => item.vat > 0);

        if (tableItems.length > 0) {
            const tableHeader = getTableHeader(btnFunc, tableItems, customizationFields, invoice);
            doc.content[3].table.body.push(tableHeader);
        }

        let totalQuantity = 0;
        tableItems.forEach(item => {
            const rowData = getRowData(invoice, item, btnFunc, !!hasFreeQuantity, !!hasTradeDiscount, !!hasOfferDiscount, !!hasVatAmount, !!hasVatPercentage, customizationFields);
            if(btnFunc == 2) {
                totalQuantity += (item.quantity + item.free_quantity);
            }
            return doc.content[3].table.body.push(rowData);
        });

        if (btnFunc == 2) {
            doc.content[3].table.body.push([
                { text: 'TOTAL', colSpan: 2, alignment: 'right' }, {},
                { text: formatCurrency(totalQuantity), alignment: 'right' }, {}
            ]);
        }
    }
    const pushIntoTableTotal = (doc, invoice, tableItems, customizationFields) => {
        const hasFreeQuantity = tableItems.find(item => item.free_quantity > 0);
        const hasTradeDiscount = tableItems.find(item => item.discount_amount > 0);
        const hasOfferDiscount = tableItems.find(item => item.offer_discount > 0);
        const hasVatAmount = tableItems.find(item => item.vat_amount > 0);
        const hasVatPercentage = tableItems.find(item => item.vat > 0);

        const data = [];

        if (shouldInclude(customizationFields,'body_table_sl')){
            data.push({ text:  '' })
        }

        data.push({text:  'Total'})

        if (shouldInclude(customizationFields,'body_table_description')){
            data.push({ text:  '' })
        }
        if (shouldInclude(customizationFields,'body_table_sku')){
            data.push({ text:  '' })
        }

        if (shouldInclude(customizationFields,'body_table_mrp')){
            data.push({ text:  '' })
        }

        if (shouldInclude(customizationFields,'body_table_qty')){
            data.push({ text:  invoice.total_quantity, alignment: 'right' })
        }

        if (shouldInclude(customizationFields,'body_table_rate')){
            data.push( { text: '', alignment: 'right' })
        }

        if (shouldInclude(customizationFields,'body_table_rate') && invoice.vat_type == 'vat_inclusive'){
            data.push( { text: '', alignment: 'right' })
        }

        data.push({text: formatCurrency(invoice.total_sale_amount), alignment: 'right'})

        if (!! hasFreeQuantity && shouldInclude(customizationFields,'body_table_bonus_qty')) {
            data.push({ text:  formatCurrency(invoice.total_free_quantity), alignment: 'right' })
        }

        if ((hasTradeDiscount && shouldInclude(customizationFields,'body_table_trade_discount')) &&
            (hasOfferDiscount && shouldInclude(customizationFields,'body_table_offer_discount')) &&
            (hasVatAmount && shouldInclude(customizationFields,'body_table_vat_amount'))) {
            data.push(
                { text: formatCurrency(invoice.total_sum_amount), alignment: 'right' },
                { text: formatCurrency(invoice.total_discount_amount), alignment: 'right' },
                { text: formatCurrency(invoice.total_offer_discount), alignment: 'right' },
                { text: formatCurrency(invoice.vat_amount), alignment: 'right' },
            );

            return doc.content[3].table.body.push(data);
        }

        if (hasVatPercentage && shouldInclude(customizationFields,'body_table_vat_percentage')) {
            data.push( { text: '', alignment: 'right' })
        }

        if (hasVatAmount && shouldInclude(customizationFields,'body_table_vat_amount')) {
            data.push({ text: formatCurrency(invoice.vat_amount), alignment: 'right' })
        }

        if (hasOfferDiscount && shouldInclude(customizationFields,'body_table_offer_discount')) {
            data.push({ text: formatCurrency(invoice.total_offer_discount), alignment: 'right' })
        }

        if (hasTradeDiscount && shouldInclude(customizationFields,'body_table_trade_discount')) {
            data.push({ text: formatCurrency(invoice.total_discount_amount), alignment: 'right' })
        }

        if ((hasTradeDiscount && shouldInclude(customizationFields,'body_table_trade_discount')) ||
            (hasOfferDiscount && shouldInclude(customizationFields,'body_table_offer_discount')) ||
            (hasVatAmount && shouldInclude(customizationFields,'body_table_vat_amount'))
        ) {
            data.push({ text: formatCurrency(invoice.total_sum_amount), alignment: 'right' })
        }

        return doc.content[3].table.body.push(data);
    }

    const formatSignature = (customizationFields, company, invoice) => {
        let companyName = (shouldInclude(customizationFields,'heading_right_company_name') && company.name)
            ? company.name : '';

        let contactName = (shouldInclude(customizationFields,'body_top_left_contact_name') && invoice.contact)
            ? invoice.contact.name : '';

        const signatures = [
            shouldInclude(customizationFields, 'signature_authorized_signature')
                ? getStaticSingleSignature(
                    'Authorized Signature',
                    'left',
                    ''
                )
                : null,

            shouldInclude(customizationFields, 'signature_receiver_signature')
                ? getStaticSingleSignature(
                    'Receiver’s Signature',
                    'right',
                    ''
                )
                : null
        ].filter(Boolean);

        return signatures.length === 0
            ? null
            : {
                alignment: 'justify',
                margin: [0, 60],
                columns: signatures.map(sig => ({
                    ...sig,
                    width: signatures.length === 1 ? '100%' : '45%',
                    stack: sig.stack
                })),
                columnGap: 50
            };
    };

    const getStaticSingleSignature = (title, alignment = 'left', subtitle = '') => ({
        stack: [
            {
                canvas: [
                    { type: 'line', x1: 0, y1: 0, x2: 90, y2: 0, lineWidth: 1 }
                ],
                alignment
            },
            {
                margin: [0, 5, 0, 0],
                text: title,
                color: 'black',
                bold: true,
                alignment
            },
            ...(subtitle
                    ? [{
                        text: `(${subtitle})`,
                        color: 'black',
                        fontSize: 9,
                        alignment
                    }]
                    : []
            )
        ]
    });

    const getTableHeader = (btnFunc, tableItems, customizationFields, invoice) => {
        if (btnFunc != 1) {
            return [
                { text: 'PARTICULARS' },
                { text: 'UNIT', alignment: 'left' },
                { text: 'DELIVERY QTY', alignment: 'right' },
                { text: 'REMARKS' }
            ]
        }

        const hasFreeQuantity = tableItems.find(item => item.free_quantity > 0);
        const hasTradeDiscount = tableItems.find(item => item.discount_amount > 0);
        const hasOfferDiscount = tableItems.find(item => item.offer_discount > 0);
        const hasVatAmount = tableItems.find(item => item.vat_amount > 0);
        const hasVatPercentage = tableItems.find(item => item.vat > 0);

        const headingRow = [];

        if (shouldInclude(customizationFields,'body_table_sl')){
            headingRow.push({ text: 'SL #' })
        }

        headingRow.push(
            { text: 'ITEM DETAILS' },
        )

        if (shouldInclude(customizationFields,'body_table_description')){
            headingRow.push({ text: 'Description' })
        }

        if (shouldInclude(customizationFields,'body_table_sku')){
            headingRow.push({ text: 'SKU' })
        }

        if (shouldInclude(customizationFields,'body_table_mrp')){
            headingRow.push({ text: 'MRP' })
        }

        if (shouldInclude(customizationFields,'body_table_qty')){
            headingRow.push({ text: 'QTY', alignment: 'right' })
        }

        if (shouldInclude(customizationFields,'body_table_rate') && invoice.vat_type != 'vat_inclusive'){
            headingRow.push({ text: 'RATE', alignment: 'right' })
        }

        if (shouldInclude(customizationFields,'body_table_rate') && invoice.vat_type == 'vat_inclusive'){
            headingRow.push(
                { text:
                        [
                            { text: 'RATE' },
                            { text: '\n (Incl. VAT)', fontSize: 6 }
                        ],
                    alignment: 'right'
                },
                { text:
                        [
                            { text: 'UNIT PRICE' },
                            { text: '\n (Excl. VAT)', fontSize: 6 }
                        ],
                    alignment: 'right'
                },
            )
        }

        headingRow.push(
            { text: 'AMOUNT', alignment: 'right' },
        )

        if (!! hasFreeQuantity && shouldInclude(customizationFields,'body_table_bonus_qty')) {
            headingRow.push({ text: 'BONUS QTY', alignment: 'right' });
        }

        if ((!! hasTradeDiscount && shouldInclude(customizationFields,'body_table_trade_discount')) &&
            (!! hasOfferDiscount && shouldInclude(customizationFields,'body_table_offer_discount')) &&
            (!! hasVatAmount && shouldInclude(customizationFields,'body_table_vat_amount'))) {
            headingRow.push(
                { text: 'TOTAL AMOUNT', alignment: 'right' },
                { text: 'TRADE DISCOUNT', alignment: 'right' },
                { text: 'OFFER DISCOUNT', alignment: 'right' },
                { text: 'VAT AMOUNT', alignment: 'right' },
            );
            return headingRow
        }

        if (!! hasVatPercentage && shouldInclude(customizationFields,'body_table_vat_percentage')) {
            headingRow.push({ text: 'VAT(%)', alignment: 'right' })
        }

        if (!! hasVatAmount && shouldInclude(customizationFields,'body_table_vat_amount')) {
            headingRow.push({ text: 'VAT AMOUNT', alignment: 'right' })
        }

        if (!! hasOfferDiscount && shouldInclude(customizationFields,'body_table_offer_discount')) {
            headingRow.push({ text: 'OFFER DISCOUNT', alignment: 'right' })
        }

        if (!! hasTradeDiscount && shouldInclude(customizationFields,'body_table_trade_discount')) {
            headingRow.push({ text: 'TRADE DISCOUNT', alignment: 'right' })
        }

        if ((!! hasTradeDiscount && shouldInclude(customizationFields,'body_table_trade_discount')) ||
            (!! hasOfferDiscount && shouldInclude(customizationFields,'body_table_offer_discount')) ||
            (!! hasVatAmount && shouldInclude(customizationFields,'body_table_vat_amount'))
        ) {
            headingRow.push({ text: 'TOTAL AMOUNT', alignment: 'right' })
        }

        return headingRow;
    }
    const getRowData = (invoice, item, btnFunc, hasFreeQuantity, hasTradeDiscount, hasOfferDiscount, hasVatAmount, hasVatPercentage, customizationFields) => {
        srNumber += 1;
        if (btnFunc != 1) {
            return [
                { text: (invoice.has_item_detail ? item.product.name : item.head.name) + '\n' + (item.description ? item.description : '') },
                { text: item.product ? item.product.description.unit.name : '' },
                { text: formatCurrency(item.quantity + item.free_quantity), alignment: 'right' },
                { text: '' }
            ]
        }

        const data = [];
        if (shouldInclude(customizationFields,'body_table_sl')){
            data.push({ text:  srNumber })
        }

        data.push(
                {
                    text: [
                        invoice.has_item_detail
                            ? item.product.name
                            : item.head.name,
                        ['initial', 'surveillance'].includes(item.sale_order_type)
                            ? '\n' + toCapitalizeFirst(item.sale_order_type)
                            : ''
                    ].filter(Boolean)
                }
            )

        if (shouldInclude(customizationFields,'body_table_description')){
            data.push( { text: item.description ? item.description : '' })
        }

        if (shouldInclude(customizationFields,'body_table_sku')){
            data.push( { text: item.product ? item.product.sku : '' })
        }

        if (shouldInclude(customizationFields,'body_table_mrp')){
            data.push( { text: item.product && item.product.description ? item.product.description.sales_price : '' })
        }

        if (shouldInclude(customizationFields,'body_table_qty')){
            data.push( { text:  invoice.has_item_detail ? item.quantity : '', alignment: 'right' })
        }

        if (shouldInclude(customizationFields,'body_table_rate')){
            data.push( { text: invoice.has_item_detail ? formatCurrency(item.rate) : '', alignment: 'right' })
        }

        if (shouldInclude(customizationFields,'body_table_rate') && invoice.vat_type == 'vat_inclusive'){
            data.push( { text: invoice.has_item_detail ? formatCurrency(item.rate - (item.vat_amount / item.quantity)) : '', alignment: 'right' })
        }

        data.push(
            {
                text: invoice.has_item_detail && invoice.vat_type != 'vat_inclusive' ?
                    formatCurrency(item.quantity * item.rate) :
                    formatCurrency(item.amount),
                alignment: 'right'
            }
        )

        if (hasFreeQuantity && shouldInclude(customizationFields,'body_table_bonus_qty')) {
            data.push({ text:  invoice.has_item_detail ? formatCurrency(item.free_quantity) : '', alignment: 'right' })
        }

        if ((hasTradeDiscount && shouldInclude(customizationFields,'body_table_trade_discount')) &&
            (hasOfferDiscount && shouldInclude(customizationFields,'body_table_offer_discount')) &&
            (hasVatAmount && shouldInclude(customizationFields,'body_table_vat_amount'))) {
            data.push(
                { text:  formatCurrency(item.total_amount), alignment: 'right' },
                { text:  invoice.has_item_detail ? formatCurrency(item.discount_amount) : '', alignment: 'right' },
                { text:  invoice.has_item_detail ? formatCurrency(item.offer_discount) : '', alignment: 'right' },
                { text: formatCurrency(item.vat_amount), alignment: 'right' },
            );

            return data
        }

        if (hasVatPercentage && shouldInclude(customizationFields,'body_table_vat_percentage')) {
            data.push({ text: formatCurrency(item.vat), alignment: 'right' })
        }

        if (hasVatAmount && shouldInclude(customizationFields,'body_table_vat_amount')) {
            data.push({ text: formatCurrency(item.vat_amount), alignment: 'right' })
        }

        if (hasOfferDiscount && shouldInclude(customizationFields,'body_table_offer_discount')) {
            data.push( { text:  invoice.has_item_detail ? formatCurrency(item.offer_discount) : '', alignment: 'right' })
        }

        if (hasTradeDiscount && shouldInclude(customizationFields,'body_table_trade_discount')) {
            data.push({ text:  formatCurrency(item.discount_amount), alignment: 'right' })
        }

        if ((hasTradeDiscount && shouldInclude(customizationFields,'body_table_trade_discount')) ||
            (hasOfferDiscount && shouldInclude(customizationFields,'body_table_offer_discount')) ||
            (hasVatAmount && shouldInclude(customizationFields,'body_table_vat_amount'))) {
            data.push({ text:  formatCurrency(item.total_amount), alignment: 'right' })
        }

        return data;
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;
